// extracted by mini-css-extract-plugin
module.exports = {"root":"PDF_root__1ivK1","name":"PDF_name__eeoQQ","size":"PDF_size__1x1N_"};